import { Banner } from "components/DesignSystem/Banner/Banner";
import { Button } from "components/DesignSystem/Button/Button";
import { SOURCE_SYNC_PAGE_SIZE } from "constants/invoiceSourceSync";
import { REVENUE_DATA_SOURCE_OPTIONS } from "constants/revenueDataSource";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useModal } from "hooks/useModal";
import { useGetInvoiceSourceSyncQuery } from "store/apis/invoiceSourceSync";
import { pluralize } from "utils/pluralize";
import { SourceChangesModal } from "./SourceChangesModal";

// Invoices page alert; hidden while every synced invoice matches its source
export const SourceSyncBanner = () => {
  const entityId = useCurrentEntityId();
  const modal = useModal();

  const { data } = useGetInvoiceSourceSyncQuery(
    { entityId, limit: SOURCE_SYNC_PAGE_SIZE },
    { skip: !entityId }
  );

  const outOfSyncCount = data?.summary.out_of_sync ?? 0;
  if (outOfSyncCount === 0) {
    return null;
  }

  const source = data?.invoices[0]?.source;
  const sourceName =
    (source && REVENUE_DATA_SOURCE_OPTIONS[source]) || "their source";
  const verb = outOfSyncCount === 1 ? "is" : "are";

  return (
    <>
      <Banner
        type="warning"
        title={`${pluralize(
          outOfSyncCount,
          "invoice",
          "invoices"
        )} ${verb} out of sync with ${sourceName}.`}
        titleClassName="t-text-text-100"
        description={`${sourceName} was updated, but those changes haven't reflected in Inkle. Review the invoices and take necessary action.`}
        cta={
          <Button type="button" size="small" onClick={modal.open}>
            Review invoices
          </Button>
        }
      />
      {modal.isOpen && (
        <SourceChangesModal open={modal.isOpen} onClose={modal.close} />
      )}
    </>
  );
};
